import React, { useEffect, useRef, useState } from 'react';
import icArrowRight1 from 'Assets/img/sidebar/ic_arrow_right_20_gray.png';
import icArrowRight2 from 'Assets/img/sidebar/ic_arrow_right_20_gray@2x.png';
import icArrowRight3 from 'Assets/img/sidebar/ic_arrow_right_20_gray@3x.png';
import { getImageSet } from 'Util/DataUtils';
import IntlMessages from 'Util/IntlMessages';

const icArrowRight = getImageSet([icArrowRight1, icArrowRight2, icArrowRight3]);

const DrawerSelectInput = ({ placeholder, value, onChange, menuItems, error, isMultiple = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = event => {
      if (!isOpen) return;
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen]);

  const renderValue = () => (
    <div
      className={`common-drawer-select-input-value ${!isOpen && error && 'error'} ${!value && 'placeholder'}`}
      style={{ borderRadius: isOpen ? '10px 10px 0 0' : '10px' }}
      onClick={() => setIsOpen(!isOpen)}
    >
      {value ? menuItems.find(item => item.value === value).label : <IntlMessages id={placeholder} />}
      <img {...icArrowRight} alt="icArrowRight" style={{ width: 15, height: 15, transform: value ? 'rotate(270deg)' : 'rotate(90deg)' }} />
    </div>
  );

  return (
    <div className="common-drawer-select-input cursor-pointer no-drag">
      {isOpen ? (
        <div ref={dropdownRef} className="common-drawer-select-input-selected">
          {renderValue()}
          <div className="common-drawer-select-input-selected-menu">
            {menuItems.map(item => (
              <div
                key={item.value}
                className="common-drawer-select-input-selected-menu-item"
                onClick={() => {
                  onChange(item.value);
                  if (!isMultiple) {
                    setIsOpen(false);
                  }
                }}
              >
                {item.label}
              </div>
            ))}
          </div>
        </div>
      ) : (
        renderValue()
      )}
    </div>
  );
};

export default DrawerSelectInput;
